import _ from 'lodash';
import { connect } from 'react-redux';
import { search, remove, getStats } from '../../modules/logistics/loadingAssignment';
import { bindActionCreators } from 'redux';
import { showErrors } from '../../modules/general';

const mapStateToProps = state => {

	/** @namespace state.lists.loadingAssignmentIds **/
	/** @namespace state.maps.loadingAssignment **/
	/** @namespace state.maps.user **/
	let loadingAssignments = [];
	if (state.lists.loadingAssignmentIds) {
		loadingAssignments = _.map(state.lists.loadingAssignmentIds, id => state.maps.loadingAssignment[id]);
	}
	const canMakeUpdates = !!(_.get(state.auth.authUser, ['permissions', 'canMakeUpdates'], false));
	return {
		loadingAssignments,
		userMap : state.maps.user,
		supplierMap : state.maps.supplier,
		terminalMap : state.maps.terminal,
		stationDeliveryMap : state.maps.stationDelivery,
		carrierMap : state.maps.carrier,
		canMakeUpdates,
	};
};
const mapDispatchToProps = dispatch => bindActionCreators({
	searchLoadingAssignments : search,
	removeLoadingAssignment : remove,
	getLoadingAssignmentStats : getStats,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
